import React, { useCallback } from 'react'
import { IconButton } from '../../../ui'

function autoResize(el) {
  if (!el) return
  el.style.height = 'auto'
  el.style.height = el.scrollHeight + 'px'
}

export function BulletListKudos({ items = [], onChange, maxItems = 5, disabled = false }) {
  const normalized = items.length === 0 ? [{ who: '', reason: '' }] : items

  function handleChange(index, field, val) {
    const next = normalized.map((item, i) => i === index ? { ...item, [field]: val } : item)
    onChange({ items: next })
  }

  function handleAdd() {
    if (normalized.length < maxItems) {
      onChange({ items: [...normalized, { who: '', reason: '' }] })
    }
  }

  function handleRemove(index) {
    if (normalized.length <= 1) {
      onChange({ items: [{ who: '', reason: '' }] })
    } else {
      onChange({ items: normalized.filter((_, i) => i !== index) })
    }
  }

  return (
    <div style={styles.wrap}>
      {normalized.map((item, index) => (
        <div key={index} style={styles.row}>
          <input
            style={styles.whoInput}
            value={item.who}
            placeholder={disabled ? '' : 'Who?'}
            maxLength={40}
            disabled={disabled}
            onChange={(e) => handleChange(index, 'who', e.target.value)}
            aria-label="Who"
          />
          <textarea
            ref={(el) => autoResize(el)}
            style={styles.reasonInput}
            value={item.reason}
            rows={1}
            placeholder={disabled ? '' : 'What did they do?'}
            maxLength={140}
            disabled={disabled}
            onChange={(e) => { handleChange(index, 'reason', e.target.value); autoResize(e.target) }}
            aria-label="Reason"
          />
          {!disabled && (
            <IconButton ariaLabel="Remove item" onClick={() => handleRemove(index)} tabIndex={-1}>×</IconButton>
          )}
        </div>
      ))}
      {!disabled && normalized.length < maxItems && (
        <button style={styles.addBtn} onClick={handleAdd}>+ add</button>
      )}
    </div>
  )
}

const styles = {
  wrap: { padding: '8px 14px 12px', display: 'flex', flexDirection: 'column', gap: '6px' },
  row: { display: 'flex', alignItems: 'flex-start', gap: '6px' },
  whoInput: {
    width: '70px', flexShrink: 0, border: 'none', outline: 'none', background: 'transparent',
    fontSize: '12px', fontWeight: 600, color: 'var(--text-primary)', padding: '2px 0',
    borderBottom: '1px solid var(--border)',
  },
  reasonInput: {
    flex: 1, border: 'none', outline: 'none', background: 'transparent',
    fontSize: '12px', color: 'var(--text-secondary)', padding: '2px 0',
    resize: 'none', overflow: 'hidden', fontFamily: 'inherit', lineHeight: '1.5',
  },
  addBtn: {
    background: 'none', border: 'none', cursor: 'pointer', fontSize: '11px',
    color: '#3b82c4', padding: '2px 0', marginTop: '2px',
  },
}
